/* eslint-disable */
const axios = require('axios');
axios.defaults.withCredentials = true;

export default class Axios {
  get(options) {
    options.method = 'get';
    options.headers = options.headers ? options.headers : this.getHeaders();

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response && response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  post(options) {
    options.method = 'POST';
    options.headers = options.headers ? options.headers : this.getHeaders();
    options.timeout = 1000 * 3000;

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  otppost(options) {
    options.method = 'POST';
    options.timeout = 1000 * 3000;

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  patch(options) {
    options.method = 'PATCH';
    options.headers = this.getHeaders();

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  put(options) {
    options.method = 'PUT';
    options.headers = this.getHeaders();

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  delete(options) {
    options.method = 'DELETE';
    options.headers = this.getHeaders();

    return new Promise((resolve, reject) => {
      axios(options)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  getHeaders() {
    return {
      Authorization: `Bearer `,
    };
  }
}
